import React, { useEffect, useState } from 'react';
interface PasswordProtectionProps {
  children: React.ReactNode;
}
export function PasswordProtection({
  children
}: PasswordProtectionProps) {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState(false);
  const CORRECT_PASSWORD = '9942';
  useEffect(() => {
    // Check if user is already authenticated
    const auth = localStorage.getItem('mint_authenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      setIsAuthenticated(true);
      localStorage.setItem('mint_authenticated', 'true');
      setError(false);
    } else {
      setError(true);
      setPassword('');
    }
  };
  if (isAuthenticated) {
    return <>{children}</>;
  }
  return <div className="min-h-screen bg-gray-800 flex items-center justify-center" data-id="element-87">
      <div className="w-full max-w-md" data-id="element-88">
        <div className="text-center mb-8" data-id="element-89">
          <h1 className="text-5xl font-bold text-white mb-2" data-id="element-90">Mint</h1>
          <p className="text-gray-400" data-id="element-91">Enter password to continue</p>
        </div>
        <div className="bg-white rounded-lg shadow-xl p-8" data-id="element-92">
          <form onSubmit={handleSubmit} data-id="element-93">
            <div className="mb-6" data-id="element-94">
              <input type="password" value={password} onChange={e => {
              setPassword(e.target.value);
              setError(false);
            }} placeholder="Enter password" className={`w-full px-4 py-3 border rounded-lg text-lg text-center focus:outline-none focus:ring-2 ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-gray-800'}`} autoFocus data-id="element-95" />
              {error && <p className="mt-2 text-sm text-red-600 text-center" data-id="element-96">
                  Incorrect password
                </p>}
            </div>
            <button type="submit" className="w-full bg-gray-800 text-white py-3 rounded-lg font-medium hover:bg-gray-700 transition-colors" data-id="element-97">
              Continue
            </button>
          </form>
        </div>
      </div>
    </div>;
}